import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  getProductClassData: {
    loading: false,
    error: null,
    data: null,
  },
  addProductClassData: {
    loading: false,
    error: null,
    data: null,
  },
  deleteProductClass: {
    loading: false,
    error: null,
    data: null,
  },
  editProductClass: {
    loading: false,
    error: null,
    data: null,
  },
};

const productClassSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
   
    getProductClassDataStart: (state) => {
      state.getProductClassData.loading = true;
      state.getProductClassData.error = null;
      state.getProductClassData.data = null;
    },
    getProductClassDataSuccess: (state, action) => {
      state.getProductClassData.loading = false;
      state.getProductClassData.data = action.payload;
      state.getProductClassData.error = null;
    },
    getProductClassDataFailure: (state, action) => {
      state.getProductClassData.loading = false;
      state.getProductClassData.error = action.payload;
      state.getProductClassData.data = null;
    },

    addProductClassStart: (state) => {
      state.addProductClassData.loading = true;
      state.addProductClassData.error = null;
      state.addProductClassData.data = null;
    },
    addProductClassSuccess: (state, action) => {
      state.addProductClassData.loading = false;
      state.addProductClassData.data = action.payload;
      state.addProductClassData.error = null;
    },
    addProductClassFailure: (state, action) => {
      state.addProductClassData.loading = false;
      state.addProductClassData.error = action.payload;
      state.addProductClassData.data = null;
    },
    addProductClassResetForm: (state, action) => {
      state.addProductClassData.loading = false;
      state.addProductClassData.error = null;
      state.addProductClassData.data = null;
    },

    deleteProductClassStart: (state) => {
      state.deleteProductClass.loading = true;
      state.deleteProductClass.error = null;
      state.deleteProductClass.data = null;
    },
    deleteProductClassSuccess: (state, action) => {
      state.deleteProductClass.loading = false;
      state.deleteProductClass.data = action.payload;
      state.deleteProductClass.error = null;
    },
    deleteProductClassFailure: (state, action) => {
      state.deleteProductClass.loading = false;
      state.deleteProductClass.error = action.payload;
      state.deleteProductClass.data = null;
    },
    deleteProductClassResetForm: (state, action) => {
      state.deleteProductClass.loading = false;
      state.deleteProductClass.error = null;
      state.deleteProductClass.data = null;
    },

    editProductClassStart: (state) => {
      state.editProductClass.loading = true;
      state.editProductClass.error = null;
      state.editProductClass.data = null;
    },
    editProductClassSuccess: (state, action) => {
      state.editProductClass.loading = false;
      state.editProductClass.data = action.payload;
      state.editProductClass.error = null;
    },
    editProductClassFailure: (state, action) => {
      state.editProductClass.loading = false;
      state.editProductClass.error = action.payload;
      state.editProductClass.data = null;
    },
    editProductClassResetForm: (state, action) => {
      state.editProductClass.loading = false;
      state.editProductClass.error = null;
      state.editProductClass.data = null;
    },
  },
});

export const {
  getProductClassDataStart,
  getProductClassDataFailure,
  getProductClassDataSuccess,

  addProductClassStart,
  addProductClassSuccess,
  addProductClassFailure,

  editProductClassStart,
  editProductClassSuccess,
  editProductClassFailure,
  editProductClassResetForm,

  deleteProductClassStart,
  deleteProductClassSuccess,
  deleteProductClassFailure,
  deleteProductClassResetForm,
} = productClassSlice.actions;

export default productClassSlice.reducer;
